import gql from 'graphql-tag'
import {
  InspectionComponentFragment,
} from '@/graphql/fragments/purchase'

export const query = gql`
  ${InspectionComponentFragment}
  query fetchInspectionComponent($id: Int!) {
    records: purchase_inspection_component_by_pk(id: $id) {
      ...InspectionComponent
    }
  }
`

export default query
